import axios from "axios";

// Lista
export const fetchCoupons = () => async (dispatch, getState) => {
  try {
    dispatch({ type: "COUPON_LIST_REQUEST" });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.get("/api/coupons/admin", {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    console.log("Fetched coupons:", data);
    dispatch({ type: "COUPON_LIST_SUCCESS", payload: data.coupons || [] });
  } catch (err) {
    dispatch({ type: "COUPON_LIST_FAIL", payload: err?.response?.data?.message || err.message });
  }
};

// Crear/Actualizar
export const upsertCoupon = (payload) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    dispatch({ type: "COUPON_UPSERT_REQUEST" });
    const { data } = await axios.post("/api/coupons/admin", payload, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    dispatch({ type: "COUPON_UPSERT_SUCCESS", payload: data.coupon });
  } catch (err) {
    dispatch({ type: "COUPON_UPSERT_FAIL", payload: err?.response?.data?.message || err.message });
  }
};

// Eliminar
export const deleteCoupon = (id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    dispatch({ type: "COUPON_DELETE_REQUEST", meta: { id } });
    await axios.delete(`/api/coupons/admin/${id}`, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    dispatch({ type: "COUPON_DELETE_SUCCESS", meta: { id } });
  } catch (err) {
    dispatch({ type: "COUPON_DELETE_FAIL", payload: err?.response?.data?.message || err.message, meta: { id } });
  }
};

// Validar cupón con carrito
export const validateCoupon = ({ code, items }) => async () => {
  const { data } = await axios.post("/api/coupons/validate", { code, items });
  return data; // { ok, discountAmount, detail, coupon, message }
};
